import { useState, useEffect } from 'react';

const EyeOpen = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
);
const EyeClosed = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
);

const PROVIDERS = [
  {
    id: 'watsonx',
    name: 'IBM watsonx.ai',
    subtitle: 'Llama 3.2 Vision',
    color: '#4361ee',
    active: true,
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
        <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
      </svg>
    ),
    fields: [
      { key: 'apiKey', label: 'API KEY', placeholder: 'Ingresa tu API Key de IBM', icon: 'key' },
      { key: 'projectId', label: 'PROJECT ID', placeholder: 'Ingresa tu Project ID', icon: 'folder' },
    ],
  },
  {
    id: 'openai',
    name: 'OpenAI',
    subtitle: 'GPT-4 Vision',
    color: '#10a37f',
    active: false,
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
        <path d="M22.28 9.37a5.88 5.88 0 00-.51-4.85 5.96 5.96 0 00-6.42-2.86A5.9 5.9 0 0011.5.5a5.96 5.96 0 00-5.69 4.13A5.88 5.88 0 001.88 8.3a5.96 5.96 0 00.73 6.98 5.88 5.88 0 00.51 4.85 5.96 5.96 0 006.42 2.86A5.9 5.9 0 0012.5 23.5a5.96 5.96 0 005.69-4.13 5.88 5.88 0 003.93-3.67 5.96 5.96 0 00-.73-6.98zM12.5 21.75a4.15 4.15 0 01-2.67-.97l.13-.07 4.44-2.56a.72.72 0 00.36-.63v-6.26l1.88 1.08a.07.07 0 01.04.05v5.18a4.18 4.18 0 01-4.18 4.18z"/>
      </svg>
    ),
    fields: [
      { key: 'apiKey', label: 'API KEY', placeholder: 'sk-...', icon: 'key' },
    ],
  },
  {
    id: 'gemini',
    name: 'Google Gemini',
    subtitle: 'Gemini Pro Vision',
    color: '#4285f4',
    active: false,
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
      </svg>
    ),
    fields: [
      { key: 'apiKey', label: 'API KEY', placeholder: 'Ingresa tu API Key de Google', icon: 'key' },
    ],
  },
  {
    id: 'claude',
    name: 'Anthropic Claude',
    subtitle: 'Claude 4 Vision',
    color: '#d97706',
    active: false,
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 12h8M12 8v8" stroke="#d97706" strokeWidth="2"/>
      </svg>
    ),
    fields: [
      { key: 'apiKey', label: 'API KEY', placeholder: 'sk-ant-...', icon: 'key' },
    ],
  },
  {
    id: 'azure',
    name: 'Azure AI Vision',
    subtitle: 'Azure Computer Vision',
    color: '#0078d4',
    active: false,
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
        <path d="M5.5 3L2 14l6.5 7L22 17.5 5.5 3z"/>
      </svg>
    ),
    fields: [
      { key: 'apiKey', label: 'API KEY', placeholder: 'Ingresa tu API Key de Azure', icon: 'key' },
      { key: 'endpoint', label: 'ENDPOINT', placeholder: 'https://tu-recurso.cognitiveservices.azure.com', icon: 'folder' },
    ],
  },
];

const FieldIcon = ({ type }) => {
  if (type === 'key') {
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
  }
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>;
};

function Config({ token, appName, onAppNameChange }) {
  const [watsonConfig, setWatsonConfig] = useState({ apiKey: '', projectId: '' });
  const [localAppName, setLocalAppName] = useState(appName || '');
  const [showFields, setShowFields] = useState({});
  const [configured, setConfigured] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savingName, setSavingName] = useState(false);
  const [message, setMessage] = useState('');
  const [nameMessage, setNameMessage] = useState('');

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await fetch('/api/config', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok) {
        setWatsonConfig({ apiKey: data.apiKeyRaw || '', projectId: data.projectIdRaw || '' });
        setConfigured(data.configured);
        if (data.appName) setLocalAppName(data.appName);
      }
    } catch (err) {
      console.error('Error cargando configuración:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      const response = await fetch('/api/config', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(watsonConfig),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error);

      setMessage('Configuración guardada correctamente.');
      setConfigured(true);
    } catch (err) {
      setMessage(`Error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveAppName = async (e) => {
    e.preventDefault();
    setSavingName(true);
    setNameMessage('');
    try {
      const response = await fetch('/api/config', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...watsonConfig, appName: localAppName }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      setNameMessage('Nombre actualizado correctamente.');
      onAppNameChange(localAppName);
    } catch (err) {
      setNameMessage(`Error: ${err.message}`);
    } finally {
      setSavingName(false);
    }
  };

  const toggleField = (providerId, fieldKey) => {
    const key = `${providerId}-${fieldKey}`;
    setShowFields((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  if (loading) {
    return (
      <div className="config-page">
        <div className="spinner" style={{ margin: '3rem auto' }}></div>
      </div>
    );
  }

  return (
    <div className="config-page">
      <h2 className="config-page-title">Configuración</h2>
      <p className="config-page-subtitle">Administra las credenciales de los proveedores de IA</p>

      <div className="config-card app-name-card">
        <div className="config-header">
          <div className="config-icon" style={{ background: '#1a1a2e' }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>
            </svg>
          </div>
          <div>
            <h2>Nombre de la aplicación</h2>
            <p className="config-subtitle">Para efectos de pruebas o MVP</p>
          </div>
        </div>
        <form onSubmit={handleSaveAppName} className="app-name-form">
          <div className="input-wrapper">
            <input
              type="text"
              value={localAppName}
              onChange={(e) => setLocalAppName(e.target.value)}
              placeholder="Nombre de la aplicación"
              required
            />
          </div>
          {nameMessage && (
            <div className={`config-message ${nameMessage.startsWith('Error') ? 'error' : 'success'}`}>
              {nameMessage}
            </div>
          )}
          <button type="submit" className="btn btn-primary config-save-btn" disabled={savingName}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/>
              <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
            </svg>
            {savingName ? 'Guardando...' : 'Guardar'}
          </button>
        </form>
      </div>

      <div className="providers-grid">
        {PROVIDERS.map((provider) => (
          <div
            key={provider.id}
            className={`config-card ${provider.active ? 'active-provider' : 'disabled-provider'}`}
          >
            <div className="config-header">
              <div className="config-icon" style={{ background: provider.color }}>
                {provider.icon}
              </div>
              <div>
                <h2>{provider.name}</h2>
                <p className="config-subtitle">{provider.subtitle}</p>
              </div>
            </div>

            {provider.active ? (
              <>
                <div className={`config-badge ${configured ? 'configured' : 'not-configured'}`}>
                  {configured ? (
                    <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg> Configurado</>
                  ) : (
                    <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> No configurado</>
                  )}
                </div>

                <form onSubmit={handleSave}>
                  {provider.fields.map((field) => {
                    const isVisible = showFields[`${provider.id}-${field.key}`];
                    return (
                      <div className="config-field" key={field.key}>
                        <label>
                          <FieldIcon type={field.icon} />
                          {field.label}
                        </label>
                        <div className="input-wrapper">
                          <input
                            type={isVisible ? 'text' : 'password'}
                            value={watsonConfig[field.key] || ''}
                            onChange={(e) =>
                              setWatsonConfig((prev) => ({ ...prev, [field.key]: e.target.value }))
                            }
                            placeholder={field.placeholder}
                            required
                          />
                          <button type="button" className="toggle-visibility" onClick={() => toggleField(provider.id, field.key)}>
                            {isVisible ? <EyeClosed /> : <EyeOpen />}
                          </button>
                        </div>
                      </div>
                    );
                  })}

                  {message && (
                    <div className={`config-message ${message.startsWith('Error') ? 'error' : 'success'}`}>
                      {message}
                    </div>
                  )}

                  <button type="submit" className="btn btn-primary config-save-btn" disabled={saving}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/>
                      <polyline points="17 21 17 13 7 13 7 21"/>
                      <polyline points="7 3 7 8 15 8"/>
                    </svg>
                    {saving ? 'Guardando...' : 'Guardar'}
                  </button>

                  <a
                    href="https://www.ibm.com/think/tutorials/multimodal-ai-python-llama"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="config-docs-link"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                    Documentación oficial de IBM watsonx.ai
                  </a>
                </form>
              </>
            ) : (
              <>
                <div className="provider-coming">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  No disponible en el plan actual
                </div>
                <div className="provider-fields-disabled">
                  {provider.fields.map((field) => (
                    <div className="config-field" key={field.key}>
                      <label>
                        <FieldIcon type={field.icon} />
                        {field.label}
                      </label>
                      <div className="input-wrapper">
                        <input type="password" placeholder={field.placeholder} disabled />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Config;
